export enum IssuesSupportedActions {
  Resolve = 'resolve',
  Reopen = 'reopen',
}
